const urlRelatoriosLog = "/v1/RelatoriosDeLog";

const service = {
  methods: {
    $obterRelatorioLogPeriodoFormacao(params) {
      return this.$api().get(`${urlRelatoriosLog}/RelatorioDeLogPeriodoDeFormacao`, params);
    },
    $obterRelatorioLogCSVPeriodoFormacao(params) {
      return this.$api().get(`${urlRelatoriosLog}/RelatorioDeLogDePeriodoDeFormacaoCsv`, params);
    },
    $obterRelatorioLogPDFPeriodoFormacao(params) {
      return this.$api().get(`${urlRelatoriosLog}/RelatorioDeLogDePeriodoDeFormacaoPDF`, this.$getParamsObject(params));
    },
  }
};

export default service;